import React from 'react';
import {connect} from 'react-redux';

// Components
import Anchor from 'Components/common/Anchor';
import BasicButton from 'Components/common/BasicButton';
import ScrollWrapper from 'Components/common/ScrollWrapper';
import {openNotification} from 'Actions/notification';
import Header from 'Components/common/Header';
import SearchInput from 'Components/common/SearchInput';
import {Grid} from '@material-ui/core';
import {Checkbox} from '@material-ui/core';
import util from 'Utils/commonUtil';
import Dialog from 'Components/common/Dialog';

// Actions
import {
    getMoreAllApplyList,
    updateAllApplyTabActive,
    updateAllApplyListSearchFields,
    backupAllApplyItem,
} from 'Actions/allApply';
import {T} from 'Actions/translate';

// Icons
import {KeyboardArrowRight} from '@material-ui/icons';

const getUserType = {
    0: T('all_apply_Customer'),
    1: 'Admin',
    2: T('all_apply_Host'),
    3: T('all_apply_Sales'),
};

class AllApplyList extends React.Component {
    pager = {
        pageNum: 0,
        pageSize: 10,
        pageTotal: 9999999999999,
    };
    state = {
        tabList: [
            {
                index: 0,
                text: T('host_abnormal_pending_approval'),
                tabFlg: 'INIT',
                testid: 'pending-tab',
            },
            {
                index: 1,
                text: T('host_abnormal_approved'),
                tabFlg: 'APPROVED',
                testid: 'approved-tab',
            },
            {
                index: 2,
                text: T('user_center_canceled'),
                tabFlg: 'CANCELLED',
                testid: 'cancelled-tab',
            },
        ],
        listLoaded: true,
        onlyLookMe: 0,
        backupOpened: false,
    };

    async componentDidMount() {
        window.scrollTo(0, 0);
        const {onlyLookMe} = this.state;
        const type = this.props.location.type && this.props.location.type;
        const onlyLook =
            (this.props.location.onlyLookMe &&
                this.props.location.onlyLookMe) ||
            onlyLookMe;

        if (type !== 'list' || type == undefined) {
            await this.props.updateAllApplyListSearchFields({
                queryKey: {$set: ''},
            });
        }
        this.setState(
            {
                onlyLookMe: onlyLook,
            },
            () => {
                this.getList();
            },
        );
    }

    getList = (flag, params) => {
        const {queryKey, tabActive} = this.props;
        const {onlyLookMe, tabList} = this.state;
        if (this.state.listLoaded === false) return;
        if (flag) {
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
        }
        this.setState({listLoaded: false});

        this.props
            .getMoreAllApplyList({
                pageNum: (params && params.pageNum) || this.pager.pageNum + 1,
                pageSize: this.pager.pageSize,
                key:
                    params && params.queryKey
                        ? params.queryKey.trim()
                        : queryKey.trim(),
                status:
                    params && params.status
                        ? params.status
                        : tabList[tabActive].tabFlg,
                onlyLookMe: onlyLookMe === 0 ? false : true,
            })
            .then((res) => {
                this.pager.pageNum = flag ? 1 : res.pageNum;
                this.pager.pageSize = res.pageSize;
                this.pager.pageTotal = res.pageTotal || 1;
                this.setState({listLoaded: true});
            })
            .catch((res) => {
                this.setState({listLoaded: true});
            });
    };

    onChange = (title, value) => {
        this.props.updateAllApplyListSearchFields({
            [title]: {$set: value},
        });
    };

    search = () => {
        let searchParam = {
            queryKey: this.props.queryKey.trim(),
            pageNum: 1,
        };

        if (!this.props.queryKey || !this.props.queryKey.trim()) {
            this.pager.pageNum = 1;
        }
        this.getList(true, searchParam);
    };

    allApplyView = (item) => {
        const {onlyLookMe} = this.state;
        this.props.history.push(`/allApplyApprovalDetails/${item.id}`, {
            id: item.id,
            onlyLookMe,
        });
    };

    goBack = () => {
        this.props.history.push('/stManagementList');
    };

    //切换tab
    handleChangeTab = (item) => {
        this.props.updateAllApplyTabActive({$set: item.index});
        this.getList(true, {status: item.tabFlg, pageNum: 1});
    };

    // 撤回
    backupApply = (id) => {
        this.setState({
            backupOpened: true,
            backupApplyID: id,
        });
    };

    closeDialog = () => {
        this.setState({
            backupOpened: false,
        });
    };

    cancelApply = () => {
        const {backupApplyID} = this.state;
        this.props
            .backupAllApplyItem(backupApplyID)
            .then((res) => {
                if (res.status === 'success') {
                    this.getList(true, {pageNum: 1});
                    this.props.openNotification(
                        T('backup_revoke_successs'),
                        'success',
                    );
                    this.setState({backupOpened: false});
                }
            })
            .catch((err) => {
                if (err.status === 'Invalid_Status') {
                    this.props.openNotification(
                        T('all_apply_confirm_invalid_status'),
                        'danger',
                    );
                } else if (err.status === 'Unauthorized_Operation') {
                    this.props.openNotification(
                        T('all_apply_confirm_No_right_to_cancel'),
                        'danger',
                    );
                }
            });
    };

    checkboxChange = (e) => {
        const value = Number(e.target.value);
        this.setState(
            {
                onlyLookMe: value === 1 ? 0 : 1,
            },
            () => {
                this.getList(true, {pageNum: 1});
            },
        );
    };
    render() {
        const {queryKey, tabActive, allApplyList} = this.props;
        const {tabList, onlyLookMe, backupOpened} = this.state;
        return (
            <div className="all-apply-list-container">
                <Header
                    hasUserCenter={true}
                    hasArrowBackIos={true}
                    backEvent={this.goBack}>
                    <div className="header-search-input">
                        <div className="all-apply-header">
                            <h2 className="header-title">{T('all_apply')}</h2>
                            <div className="all-apply-checkbox">
                                <Checkbox
                                    checked={onlyLookMe === 1}
                                    onChange={this.checkboxChange}
                                    value={onlyLookMe}
                                    className={
                                        onlyLookMe
                                            ? 'radio-button checked'
                                            : 'radio-button'
                                    }
                                />{' '}
                                <p
                                    className="all-apply-checkbox-word"
                                    testid="all-apply-look-self">
                                    {T('all_apply_look_self')}
                                </p>
                            </div>
                        </div>
                        <SearchInput
                            title="queryKey"
                            defaultValue={queryKey}
                            testid="all-apply-search-input"
                            value={queryKey}
                            placeholder={T(
                                'b2b_management_enter_st_or_subject',
                            )}
                            search={this.search}
                            onChange={this.onChange}></SearchInput>
                    </div>
                    <div className="tab-header">
                        {tabList.map((item, index) => {
                            return (
                                <Anchor
                                    key={item.index}
                                    className={util.getClassName({
                                        'tab-item': true,
                                        active: index === tabActive,
                                    })}
                                    testid={item.testid}
                                    onClickOfSingleTap={() => {
                                        this.handleChangeTab(item);
                                    }}>
                                    {item.text}
                                </Anchor>
                            );
                        })}
                    </div>
                </Header>

                <ScrollWrapper
                    listLoaded={this.state.listLoaded}
                    showAbyss={this.pager.pageNum >= this.pager.pageTotal}
                    showLoadingMore={!this.state.listLoaded}
                    getMoreData={this.getList}>
                    <ul className="all-apply-list">
                        {allApplyList.length > 0 &&
                            allApplyList.map((item, index) => (
                                <li
                                    className="all-apply-item"
                                    key={index}
                                    testid="all-apply-card"
                                    data-shipto={item.shipTo}
                                    data-application-id={item.id}>
                                    <div
                                        onClick={() => {
                                            this.allApplyView(item);
                                        }}>
                                        <div className="all-apply-item-title">
                                            <h5
                                                className="platform-shipto-infor"
                                                testid={item.shipTo}>
                                                {item.shipTo}
                                            </h5>
                                            <Anchor className="all-apply-item-right-icon">
                                                <KeyboardArrowRight data-testid="all-apply-arrow-right-icon" />
                                            </Anchor>
                                        </div>
                                        <section className="all-apply-info">
                                            <div>
                                                <p className="row text-ellipsis">
                                                    <label>
                                                        {T(
                                                            'all_apply_applicant',
                                                        )}
                                                        :
                                                    </label>{' '}
                                                    {`${item.applyUser}(${
                                                        getUserType[
                                                            item.userType
                                                        ]
                                                    })`}
                                                </p>
                                                <p className="row text-ellipsis">
                                                    <label>
                                                        {T('order_subject')}:
                                                    </label>{' '}
                                                    {item.stAlphaName &&
                                                    item.stAlphaName.length > 22
                                                        ? item.stAlphaName.substr(
                                                              0,
                                                              22,
                                                          )
                                                        : item.stAlphaName}
                                                </p>
                                                <p className="row text-ellipsis">
                                                    <label>
                                                        {item.status ===
                                                            'APPROVED' ||
                                                        item.status === 'REJECT'
                                                            ? T(
                                                                  'all_apply_actual_supply_center',
                                                              )
                                                            : T(
                                                                  'all_apply_apply_sc',
                                                              )}
                                                        :
                                                    </label>
                                                    {item.status ===
                                                        'APPROVED' ||
                                                    item.status === 'REJECT'
                                                        ? item.approvedActualCoveredSiteNum
                                                            ? item.approvedActualCoveredSiteName
                                                            : T('order_no_name')
                                                        : item.applyActualCoveredSiteNum
                                                        ? item.applyActualCoveredSiteName
                                                        : T('order_no_name')}
                                                </p>
                                                <p className="row text-ellipsis">
                                                    <label>
                                                        {item.status ===
                                                            'APPROVED' ||
                                                        item.status === 'REJECT'
                                                            ? T(
                                                                  'all_apply_approval_time',
                                                              )
                                                            : T(
                                                                  'all_apply_apply_time',
                                                              )}
                                                        :
                                                    </label>{' '}
                                                    {item.status ===
                                                        'APPROVED' ||
                                                    item.status === 'REJECT'
                                                        ? item.approvedTime
                                                        : item.applyTime}
                                                </p>
                                            </div>
                                        </section>
                                    </div>
                                    {tabActive === 0 && item.canCancel ? (
                                        <div className="all-apply-card-btn">
                                            <BasicButton
                                                className="new-transfer-btn"
                                                testid="withdraw-button"
                                                type="primary"
                                                isStopPropagation={true}
                                                onClickOfSingleTap={() => {
                                                    this.backupApply(item.id);
                                                }}>
                                                {T('backup_revoke')}
                                            </BasicButton>
                                        </div>
                                    ) : null}
                                </li>
                            ))}
                    </ul>
                </ScrollWrapper>

                <Dialog
                    dialogDidClose={this.closeDialog}
                    opened={backupOpened}
                    options={{bgClickClose: true}}>
                    <div className="logout-dialog" testid="all-apply-withdraw">
                        <Grid className="dialog-title" container spacing={0}>
                            <Grid item xs={12}>
                                <span>
                                    {T('all_apply_confirm_backup_title')}
                                </span>
                            </Grid>
                        </Grid>

                        <Grid
                            className="dialog-content"
                            container
                            spacing={0}
                            justify={'center'}>
                            <Grid item xs={12}>
                                <span>{T('all_apply_confirm_backup')}</span>
                            </Grid>
                        </Grid>

                        <Grid container spacing={0}>
                            <Grid item xs={12} align="center">
                                <BasicButton
                                    className="confirm-btn"
                                    testid="confirm-button"
                                    type="primary"
                                    disabled={false}
                                    onClickOfSingleTap={this.cancelApply}>
                                    <span>{T('backup_revoke')}</span>
                                </BasicButton>
                                <BasicButton
                                    className="all_apply_confirm-btn-cancel"
                                    testid="cancelled-tab"
                                    type="primary"
                                    disabled={false}
                                    onClickOfSingleTap={this.closeDialog}>
                                    <span>{T('cancel')}</span>
                                </BasicButton>
                            </Grid>
                        </Grid>
                    </div>
                </Dialog>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const {localData, allApply} = state;
    return {
        localData,
        queryKey: allApply.searchfields.queryKey,
        tabActive: allApply.tabActive,
        allApplyList: allApply.allApplyList,
    };
};

const mapDispatchToProps = {
    openNotification,
    updateAllApplyTabActive,
    updateAllApplyListSearchFields,
    getMoreAllApplyList,
    backupAllApplyItem,
};

export default connect(mapStateToProps, mapDispatchToProps)(AllApplyList);
